import {Text, View} from "@react-pdf/renderer";
import React, {useContext} from "react";

import { baseStyles } from "../styles";
import {PDFContext} from "../BasePDF";

export const RebatesBreakdownPDF = () => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null;

    const appliedRebates = pdfData.applied_rebates.filter(r => r.amount !== '0')

    if (!appliedRebates.length) return null;

    return (
        <View style={{...baseStyles.table}}>
            <View style={{...baseStyles.tableHeader, backgroundColor: pdfData.pageColor}}>
                <Text>Rebates Breakdown</Text>
            </View>

            {/*<View style={{...baseStyles.flexBetween}}>*/}
            {/*    <Text*/}
            {/*        style={{...baseStyles.bold, width: '90%'}}*/}
            {/*    >*/}
            {/*        Name*/}
            {/*    </Text>*/}

            {/*    <Text*/}
            {/*        style={{...baseStyles.bold, ...baseStyles.alignEnd, width: '10%', textAlign: 'end'}}*/}
            {/*    >*/}
            {/*        Amt*/}
            {/*    </Text>*/}
            {/*</View>*/}
            <View>
                {
                    appliedRebates.map((t) => {
                        return (
                            <View
                                key={`${t.name}-${t.amount}`}
                                style={{...baseStyles.flexBetween}}
                            >
                                <Text
                                    style={{width: '50%'}}
                                >
                                    {t.name}
                                </Text>
                                <Text
                                    style={{width: '15%', textAlign: 'end'}}
                                >
                                    {(t.amount * -1).toDollarFormat()}
                                </Text>
                            </View>
                        )
                    })
                }
                <View
                    style={{...baseStyles.flexBetween, ...baseStyles.boldTopBorder}}
                >
                    <Text
                        style={{width: '90%'}}
                    >
                        Total Rebates
                    </Text>
                    <Text
                        style={{width: '15%', textAlign: 'end'}}
                    >
                        {pdfData.total_rebates.toDollarFormat()}
                    </Text>
                </View>
            </View>
        </View>
    )
}